export default __webpack_public_path__ + "static/media/pencil-white.e93c5bf1.svg";